export default __webpack_public_path__ + "static/evan-you-dd7ed91b231e6a53c2769f180c3335d8.jpg";